import { hasValue } from './hasValue';

/*
 * Function to get all the FEATURE_ env variables and return their values
 * */
export function getFeaturesFromEnvVars(featureKey = 'FEATURE_') {
  if (!hasValue(process.env)) {
    return [];
  }

  const features = [];

  for (const key in process.env) {
    if (
      key.startsWith(featureKey) &&
      Object.prototype.hasOwnProperty.call(process.env, key)
    ) {
      features.push({
        name: key,
        value: process.env[key] ?? '',
      });
    }
  }

  return features;
}
